import React from 'react';
import { TableRow, TableCell, TableHead } from '@mui/material';

function HeadTable({ headLabel }) {
  return (
    <TableHead>
      <TableRow>
        {headLabel?.map(headCell => (
          <TableCell key={headCell.id} style={{ whiteSpace: 'nowrap' }}>
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default HeadTable;
